
import React, { useState } from 'react';
import { useQueryClient } from 'react-query';
import { Plus, CheckCircle, XCircle } from 'lucide-react';
import Sidebar from '../../Dashboard/DashboarEntreprise/Sidebar';
import { Navbar } from './Navbar';
import AddAdminModal from '../../../components/applications/AddAdminModal';
import AdminList from './AdminList';
import Navbar0 from '../../../../vitrine/Components/Navbar';
import { useAdminInfo } from './hooksUseretApplication/hookAdmin Info';
import { Admin } from '../../../api/ApiAdmin';
import { useTranslation } from '../../../../TranslationContext';

// Fonction pour convertir AdminInfo en Admin si nécessaire
const mapAdminInfoToAdmin = (adminInfo: any): Admin | null => {
  if (!adminInfo) return null;
  return {
    id: adminInfo.id,
    email: adminInfo.email,
    fullName: adminInfo.fullName,
    default: adminInfo.default ?? false,
  };
};

const AdminPage: React.FC = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const [isAdminModalOpen, setAdminModalOpen] = useState(false);
  const companyId = localStorage.getItem('company');
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const { adminInfo, isLoading, isError } = useAdminInfo();
  const currentAdmin = mapAdminInfoToAdmin(adminInfo);

  const handleAdminCreated = () => {
    setAdminModalOpen(false);
    queryClient.invalidateQueries(['admins', companyId]);
    setSuccessMessage(t('admin_created_successfully'));
    setTimeout(() => setSuccessMessage(null), 5000);
  };

  const handleError = (message: string) => {
    setErrorMessage(message);
    setTimeout(() => setErrorMessage(null), 5000);
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex justify-center items-center">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-indigo-500"></div>
        <span className="ml-3 text-indigo-600">{t('loading_user')}</span>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="min-h-screen bg-gray-50 flex justify-center items-center">
        <p className="text-red-600">{t('error_loading_user')}</p>
      </div>
    );
  }

  const isSuperAdmin = currentAdmin?.default ?? false;

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar0 />
      <Navbar />

      {/* Messages de notification */}
      <div className="fixed top-20 right-4 space-y-2 z-50">
        {successMessage && (
          <div className="bg-green-50 border border-green-200 text-green-700 px-6 py-4 rounded-md shadow-lg flex items-center animate-fade-in-up">
            <CheckCircle className="h-5 w-5 mr-2" />
            {successMessage}
          </div>
        )}
        {errorMessage && (
          <div className="bg-red-50 border border-red-200 text-red-700 px-6 py-4 rounded-md shadow-lg flex items-center animate-fade-in-up">
            <XCircle className="h-5 w-5 mr-2" />
            {errorMessage}
          </div>
        )}
      </div>

      <div className="flex">
        <div className="w-1/4">
          <Sidebar />
        </div>

        <div className="w-3/4 p-6 space-y-6">
          <div className="flex justify-between items-center">
            <h1 className="mt-30 text-2xl font-semibold text-gray-800">
              {t('admin_management')}
            </h1>
            <button
              onClick={() => setAdminModalOpen(true)}
              className={`flex items-center px-4 py-2 rounded-md transition-colors ${
                isSuperAdmin
                  ? 'bg-slate-700 text-white hover:bg-slate-800'
                  : 'bg-gray-300 text-gray-500 cursor-not-allowed'
              }`}
              disabled={!isSuperAdmin}
              title={!isSuperAdmin ? t('only_super_admins_can_create') : ''}
            >
              <Plus className="w-4 h-4 mr-2" /> {t('create_admin')}
            </button>
          </div>

          <AddAdminModal
            isOpen={isAdminModalOpen}
            onClose={() => setAdminModalOpen(false)}
            onAdminCreated={handleAdminCreated}
            onError={handleError}
          />

          <AdminList companyId={companyId} currentAdmin={currentAdmin} />
        </div>
      </div>
    </div>
  );
};

export default AdminPage;
// import React, { useState } from 'react';
// import { useQueryClient } from 'react-query';
// import { Plus, CheckCircle, XCircle } from 'lucide-react';
// import Sidebar from '../../Dashboard/DashboarEntreprise/Sidebar';
// import { Navbar } from './Navbar';
// import AddAdminModal from '../../../components/applications/AddAdminModal';
// import AdminList from './AdminList';
// import Navbar0 from '../../../../vitrine/Components/Navbar';
// import { useAdminInfo } from './hooksUseretApplication/hookAdmin Info';
// import { Admin } from './ApiAdmin';

// // Fonction pour convertir AdminInfo en Admin si nécessaire
// const mapAdminInfoToAdmin = (adminInfo: any): Admin | null => {
//   if (!adminInfo) return null;
//   return {
//     id: adminInfo.id,
//     email: adminInfo.email,
//     fullName: adminInfo.fullName,
//     default: adminInfo.default ?? false,
//   };
// };

// const AdminPage: React.FC = () => {
//   const queryClient = useQueryClient();
//   const [isAdminModalOpen, setAdminModalOpen] = useState(false);
//   const companyId = localStorage.getItem('company');
//   const [successMessage, setSuccessMessage] = useState<string | null>(null);
//   const [errorMessage, setErrorMessage] = useState<string | null>(null);

//   const { adminInfo, isLoading, isError } = useAdminInfo();
//   const currentAdmin = mapAdminInfoToAdmin(adminInfo);

//   const handleAdminCreated = () => {
//     setAdminModalOpen(false);
//     queryClient.invalidateQueries(['admins', companyId]);
//     setSuccessMessage('Administrateur créé avec succès ! 🎉');
//     setTimeout(() => setSuccessMessage(null), 5000);
//   };

//   const handleError = (message: string) => {
//     setErrorMessage(message);
//     setTimeout(() => setErrorMessage(null), 5000);
//   };

//   if (isLoading) {
//     return (
//       <div className="min-h-screen bg-gray-50 flex justify-center items-center">
//         <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-indigo-500"></div>
//         <span className="ml-3 text-indigo-600">Chargement de l'utilisateur...</span>
//       </div>
//     );
//   }

//   if (isError) {
//     return (
//       <div className="min-h-screen bg-gray-50 flex justify-center items-center">
//         <p className="text-red-600">Erreur lors du chargement de l'utilisateur. Veuillez réessayer.</p>
//       </div>
//     );
//   }

//   const isSuperAdmin = currentAdmin?.default ?? false;

//   return (
//     <div className="min-h-screen bg-gray-50">
//       <Navbar0 />
//       <Navbar />

//       {/* Messages de notification */}
//       <div className="fixed top-20 right-4 space-y-2 z-50">
//         {successMessage && (
//           <div className="bg-green-50 border border-green-200 text-green-700 px-6 py-4 rounded-md shadow-lg flex items-center animate-fade-in-up">
//             <CheckCircle className="h-5 w-5 mr-2" />
//             {successMessage}
//           </div>
//         )}
//         {errorMessage && (
//           <div className="bg-red-50 border border-red-200 text-red-700 px-6 py-4 rounded-md shadow-lg flex items-center animate-fade-in-up">
//             <XCircle className="h-5 w-5 mr-2" />
//             {errorMessage}
//           </div>
//         )}
//       </div>

//       <div className="flex">
//         <div className="w-1/4">
//           <Sidebar />
//         </div>

//         <div className="w-3/4 p-6 space-y-6">
//           <div className="flex justify-between items-center">
//             <h1 className="mt-30 text-2xl font-semibold text-gray-800">
//               Gestion des administrateurs
//             </h1>
//             <button
//               onClick={() => setAdminModalOpen(true)}
//               className={`flex items-center px-4 py-2 rounded-md transition-colors ${
//                 isSuperAdmin
//                   ? 'bg-slate-700 text-white hover:bg-slate-800'
//                   : 'bg-gray-300 text-gray-500 cursor-not-allowed'
//               }`}
//               disabled={!isSuperAdmin}
//               title={!isSuperAdmin ? 'Seuls les super administrateurs peuvent créer des administrateurs' : ''}
//             >
//               <Plus className="w-4 h-4 mr-2" /> Créer un administrateur
//             </button>
//           </div>

//           <AddAdminModal
//             isOpen={isAdminModalOpen}
//             onClose={() => setAdminModalOpen(false)}
//             onAdminCreated={handleAdminCreated}
//             onError={handleError}
//           />

//           <AdminList companyId={companyId} currentAdmin={currentAdmin} />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdminPage;